import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getWorklineCargoes({ callid, sofid }: { callid: string | number; sofid: string | number }) {
  const data = await apiGet(`sof/worklineCargoes/${callid}/${sofid}`);
  useHelperStore().setWorklineCargoes(data);
}
